import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/algorithms/AlgorithmVisualizer.tsx");
